

export class SystemFeatureFlagConsts{
    public static readonly SystemFeatureFlagAccreditationOn = "systemFeatureFlagAccreditationOn";

    public static get getAll(): string[]{
        return [
            SystemFeatureFlagConsts.SystemFeatureFlagAccreditationOn
        ]
    }
}